import { createTheme } from "@mui/material/styles";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    manufacturer: true;
    reseller: true;
  }
}
declare module "@mui/material/TableCell" {
  interface TableCellPropsVariantOverrides {
    item: true;
  }
}

declare module '@mui/material/styles/components' {
  interface Components {
    MuiTimelineContent?: {
      styleOverrides?: {
        root?: React.CSSProperties;
      };
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#582c83",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fe2824",
      contrastText: "#fff",
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontSize: 12,
    fontFamily: "Inter, Arial, sans-serif",
    allVariants: {
      color: "#374151"
    },
    h1: {
      fontWeight: 'bold',
      fontSize: 22,
    },
    h2: {
      fontWeight: 'bold',
      fontSize: 18,

    },
    h3: {
      fontWeight: 'bold',
      fontSize: 16,
    },
    h4: {
      fontWeight: 'bold',
      fontSize: 14,
    },
    h5: {
      fontWeight: 'bold',
      fontSize: 13,
    },
    h6: {
      fontWeight: 'bold',
      fontSize: 12,
    },
    subtitle1: {
      fontSize: 13,
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: 13,
      color: '#6c6c6c'
    },
    body2: {
      lineHeight: '1.25rem',
      color: '#505050'
    }
  },
});

const customShadow = 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px';

theme.components = {
  MuiAccordion: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        marginBottom: theme.spacing(),
        boxShadow: customShadow
      }
    }
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: "none",
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textDecoration: "none",
        borderRadius: 24,
        textTransform: "none",
        fontFamily: "Inter, Arial, sans-serif",
        fontWeight: 600,
        textAlign: "center",
      },
    },
    defaultProps: {
      disableRipple: true,
      disableElevation: true,
    },
    variants: [
      {
        props: { variant: "manufacturer" },
        style: {
          backgroundColor: "#4F307F",
          color: "white",
          "&:hover": {
            backgroundColor: "#705893",
          },
        },
      },
      {
        props: { variant: "reseller" },
        style: {
          backgroundColor: "#376AD3",
          color: "white",
          "&:hover": {
            backgroundColor: "#698fde",
          },
        },
      },
    ],
  },
  MuiButtonBase: {
    styleOverrides: {
      root: {
        borderRadius: 1,
        textDecoration: "none",
      },
    },
  },
  MuiButtonGroup: {
    defaultProps: {
      disableRipple: true,
      disableElevation: true,
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        padding: theme.spacing(2),
        boxShadow: customShadow
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      a: {
        color: 'inherit',
        textDecorationColor: '#c2c2c2',
        textUnderlineOffset: 4,
      }
    }
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: "#363636",
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        fontSize: 12
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: customShadow,
        overflowX: "auto",
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: {
        fontSize: 12
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        margin: "0px 8px 0px 8px",
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontWeight: 600,
        color: "#363636",
        fontSize: 16,
      }
    },
    defaultProps: {
      align: "center",
    },
    variants: [
      {
        props: { variant: "item" },
        style: {
          padding: theme.spacing(),
          height: "72px",
          paddingLeft: "25px"
        },
      },
    ],
  },
  MuiTablePagination: {
    defaultProps: {
      rowsPerPageOptions: [20, 50, 100],
      SelectProps: { native: true },
      showFirstButton: true,
      showLastButton: true,
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        boxShadow: customShadow
      }
    },
    defaultProps: {
      variant: "scrollable"
    }
  },
  MuiTimelineContent: {
    styleOverrides: {
      root: {
        marginLeft: 28,
      }
    }
  }
};

export default theme;
